let questions = document.querySelectorAll(".FAQ-item").forEach(item => {
    item.addEventListener('click',() =>{
        item.classList.toggle("active");
    })
})
